(function () {
    'use strict';
  
    /* @ngdoc object
     * @name cosmicRadiation
     * @description
     *
     */
    angular
      .module('cosmicRadiation', [
        'ui.router'
      ]);
  }());